import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Row } from 'react-bootstrap';

import HomeSlider from '../../../Home/HomeSlider';
import messages from '../../../../locale/messages';
import { withQuery } from '../../../../hoc/withGraphql';
import ManageListingsQuery from './ManageListingsProfile.graphql';
import s from './PanelWrapper.css';

const PanelWrapper = ({ ManageListingsData: { loading, ManageListingsProfile }, firstName }) => {
    return (
        <>
            {ManageListingsProfile && ManageListingsProfile?.length > 0 && (
                <>
                    <div className={s.lineCss}></div>
                    <h3 className={s.subTitle}>
                        {firstName}'s{' '}
                        {ManageListingsProfile.length > 1 ? (
                            <FormattedMessage {...messages.mapListing} />
                        ) : (
                            <FormattedMessage {...messages.singularListingLabel} />
                        )}
                    </h3>
                    <div className={s.subContent}>
                        <div className={cx(s.pageContainer, s.spaceTop4, 'ViewProfile')}>
                            <Row>
                                <HomeSlider
                                    data={ManageListingsProfile}
                                    fromPage="viewProfile"
                                    hideHeading
                                    skeletonClass='viewProfileListSkeleton'
                                />
                            </Row>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

PanelWrapper.propTypes = {
    ManageListingsData: PropTypes.shape({
        loading: PropTypes.bool,
        ManageListingsProfile: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    firstName: PropTypes.string,
    userId: PropTypes.string,
};

PanelWrapper.defaultProps = {
    ManageListingsData: {
        ManageListingsProfile: [],
        loading: true,
    },
};

export default withQuery(ManageListingsQuery, {
    name: 'ManageListingsData',
    options: (props) => ({
        variables: {
            userId: props.userId,
        },
        fetchPolicy: 'network-only',
        ssr: false,
    }),
})(withStyles(s)(PanelWrapper));